import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from '../Components/Header';
import ConnectModal from "../Connect Wallet/ConnectModal";
import SetPassword from "../Connect Wallet/SetPassword";
import axios from 'axios';
import { toast } from 'react-toastify';

const Home = () => {
  const [isConnectModalOpen, setIsConnectModalOpen] = useState(false);
  const { data } = useSelector((state) => state.user);
  const navigate = useNavigate();

  const handleWalletClick = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return navigate("/connect-wal");
    }

    // ✅ Already verified password once
    if (localStorage.getItem("passwordVerified") === "true") {
      return navigate("/wallet");
    }

    // 🔐 Try checking wallet access
    try {
      const headers = { Authorization: `Bearer ${token}` };

      await Promise.all([
        axios.get("http://159.203.35.6:8080/wallet/getAssetsByChain?chainId=1", { headers }),
        axios.get("http://159.203.35.6:8080/wallet/getPublicKeyEvmGenerated", { headers }),
      ]);

      // ✅ Access is valid, ask for password only if not verified
      setIsConnectModalOpen(true);
    } catch (err) {
      if (err?.response?.status === 403) {
        navigate("/connect-wal");
      } else {
        toast.error("Unable to access wallet. Please try again.");
      }
    }
  };
  return (
    <div className='home-background'>
      <div className='home-create'>
        <Header showHeader={true} />
        <div className='home-index'>
          <div className="container">
            <div className="button-group">
              <div className='button-more'>
                <Link to="/CEX" className="button">
                  <span className="label">CENTRALIZED EXCHANGE</span>
                  <span className="code">CEX</span>
                </Link>
              </div>
              <div className='button-more'>
                <Link to="/DEX" className="button">
                  <span className="label">DECENTRALIZED EXCHANGE</span>
                  <span className="code">DEX</span>
                </Link>
              </div>
              <div className='button-more'>
                <Link to="/private-sale" className="button">
                  <span className="label">PRIVATE SALE</span>
                  <span className="code">PS</span>
                </Link>
              </div>
              <div className='button-more'>
                <Link to="/check-scam" className="button">
                  <span className="label">Scam Token Identifier</span>
                  <span className="code">STI</span>
                </Link>
              </div>
              {/* My Watch List */}
              <div className='button-more'>
                <Link to="/watch-list" className="button">
                  <span className="label">My Watch List</span>
                  <span className="code">FAV</span>
                </Link>
              </div>
              {/* Wallet Button */}
              <div className='button-more' onClick={handleWalletClick}>
                <button className="button">
                  <span className="label">Wallet</span>
                  <span className="code">WAL</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isConnectModalOpen && (
        data?.WalletStatus === true ? (
          <ConnectModal onClose={() => setIsConnectModalOpen(false)} />
        ) : (
          <SetPassword onClose={() => setIsConnectModalOpen(false)} />
        )
      )}
    </div>
  );
};

export default Home;

